export default __webpack_public_path__ + "static/2024_PCS_Flyer-d2c33dbfe99a60c3802a1a16b790a508.pdf";